export class IEvents {}